import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'));
